export default "__VITE_PUBLIC_ASSET__ae723d0c__"